module.exports = __webpack_public_path__ + "static/img/picture_icon.f85cca6c.png";